document.getElementById('tc-button-mobile').addEventListener('click',function(){

    let TCDropdown = document.getElementById('tc-dropdown-mobile');
    this.classList.toggle('open');
    if(window.getComputedStyle(TCDropdown, null).display == 'none') {
        Velocity(TCDropdown, 'slideDown', {duration: 300, display: 'block'});
    } else {
        Velocity(TCDropdown, 'slideUp', {duration: 300, display: 'none'});
    }
});

function findPos(obj) {
	var curleft = 0;
	var curtop = 0;

	if (obj.offsetParent) {

		do {
			curleft += obj.offsetLeft;
			curtop += obj.offsetTop;

		} while (obj = obj.offsetParent);

		return [curleft,curtop];
	}

}

function getPosition(element) {
    var clientRect = element.getBoundingClientRect();
    return {left: clientRect.left + document.body.scrollLeft,
            top: clientRect.top + document.body.scrollTop};
}

var scrollLinksTC = [].slice.call(document.querySelectorAll('.scroll-link-tc'));

scrollLinksTC.forEach(function(scrollLink) {
    scrollLink.addEventListener('click', function(e) {
        if(this.tagName == 'A')
            e.preventDefault();

        let header = document.querySelector(this.getAttribute('href'));
        let tcHeight = document.getElementById('tc-dropdown-mobile').offsetHeight + 80;
        let tcHeightMid = document.getElementById('tc-dropdown-mobile').offsetHeight + 160;

        if (window.innerWidth > 1199) {
            Velocity(header, 'scroll', { duration: 800, offset: -headerHeight });
        } else if (window.innerWidth >= 768 && window.innerWidth <= 1199) {
            Velocity(header, 'scroll', { duration: 800, offset: -tcHeightMid });
        } else {
            Velocity(header, 'scroll', { duration: 800, offset: -tcHeight });
        }
        
    });
});